module.exports = __webpack_public_path__ + "img/new_icon.8336f4a0.gif";